import Layout from "@/components/layout/Layout";

export default function NotFound404Page() {
  return (
    <Layout>
      <div className="flex flex-col justify-center items-center h-screen">
        <h3 className="font-semibold text-2xl">Oops!</h3>
        <p className="mt-4">
          It seems like the page you are looking is not available.
        </p>
      </div>
    </Layout>
  );
}
